export const CA_PROVINCES = [
  { name: 'Alberta',                   abbr: 'AB', cities: ['calgary','edmonton','red deer','lethbridge','airdrie','medicine hat','grande prairie','fort mcmurray','camrose','cochrane','blackfalds','bonnyville','leduc','olds','acme','banff','brooks','fort macleod','rocky view','stony plain','diamond city'] },
  { name: 'British Columbia',          abbr: 'BC', cities: ['vancouver','victoria','surrey','burnaby','richmond','abbotsford','kelowna','prince george','cranbrook','maple ridge','vranbrook'] },
  { name: 'Manitoba',                  abbr: 'MB', cities: ['winnipeg','brandon'] },
  { name: 'New Brunswick',             abbr: 'NB', cities: ['moncton','saint john','fredericton'] },
  { name: 'Newfoundland and Labrador', abbr: 'NL', cities: ["st. john's",'corner brook'] },
  { name: 'Northwest Territories',     abbr: 'NT', cities: ['yellowknife'] },
  { name: 'Nova Scotia',               abbr: 'NS', cities: ['halifax','dartmouth','sydney'] },
  { name: 'Nunavut',                   abbr: 'NU', cities: ['iqaluit'] },
  { name: 'Ontario',                   abbr: 'ON', cities: ['toronto','ottawa','mississauga','brampton','hamilton','london','markham','vaughan','kitchener','windsor','scarborough'] },
  { name: 'Prince Edward Island',      abbr: 'PE', cities: ['charlottetown','summerside'] },
  { name: 'Quebec',                    abbr: 'QC', cities: ['montreal','québec','laval','gatineau','longueuil','sherbrooke','montréal'] },
  { name: 'Saskatchewan',              abbr: 'SK', cities: ['saskatoon','regina'] },
  { name: 'Yukon',                     abbr: 'YT', cities: ['whitehorse'] },
];

export function matchesProvince(region, provinceAbbr) {
  if (!region) return false;
  const prov = CA_PROVINCES.find(p => p.abbr === provinceAbbr);
  if (!prov) return false;
  const r = region.toLowerCase();
  if (r.includes(prov.name.toLowerCase())) return true;
  if (new RegExp(`\\b${prov.abbr}\\b`, 'i').test(region)) return true;
  return prov.cities.some(city => r.includes(city));
}
